import { render, staticRenderFns } from "./ProfessionalPracticeTermsUpdate.vue?vue&type=template&id=3a792260"
import script from "./ProfessionalPracticeTermsUpdate.vue?vue&type=script&lang=js"
export * from "./ProfessionalPracticeTermsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports